import { OrdenEstado, colorMapping } from 'src/utils/enums/OrdenEstado';
import { OrdenFormState } from './types';
import {
  colorMapping as colorMappingPriority,
  PrioridadEstado,
} from 'src/utils/enums/PrioridadEstado';
import {
  colorMapping as colorMappingPaymentStatus,
  OrdenEstadoDePago,
  OrdenEstadoDePagoLabels,
} from 'src/utils/enums/OrdenEstadoDePago';
import {
  anularOrdenF,
  marcarRecibidaOrdenF,
  marcarEnProduccionOrdenF,
  terminarOrdenF,
  marcarControladaOrdenF,
  marcarDespachadaOrdenF,
  marcarPlanificadaOrdenF,
  rechazarOrdenF,
  finalizarOrdenF,
} from './apiThunk';
import { RootState } from 'src/app/store';
import { createSlice } from '@reduxjs/toolkit';

const initialState: OrdenFormState = {
  status: null,
  priority: null,
  paymentStatus: null,
  previousState: undefined,

  actions: null,

  data: null,
  summary: null,
  productos: null,
};

const formSlice = createSlice({
  name: 'ordenForm',
  initialState,
  reducers: {
    resetForm(state) {
      state.data = null;
      state.status = null;
      state.actions = null;
      state.priority = null;
      state.productos = null;
      state.previousState = null;
    },
    setFormStatusBorrador(state) {
      setBorrador(state);
    },
    setFormStatusAnulada(state) {
      setAnulada(state);
    },
    setFormStatusRecibida(state) {
      setRecibida(state);
    },
    setFormStatusPlanificada(state) {
      setPlanificada(state);
    },
    setFormStatusProduccion(state) {
      setProduccion(state);
    },
    setFormStatusTerminada(state) {
      setTerminada(state);
    },
    setFormStatusControlada(state) {
      setControlada(state);
    },
    setFormStatusDespachada(state) {
      setDespachada(state);
    },
    setFormStatusRechazada(state) {
      setRechazada(state);
    },
    setFormStatusFinalizada(state) {
      setFinalizada(state);
    },
    setFormPriority(state, action) {
      const priority: PrioridadEstado = action.payload;

      state.priority = {
        id: priority,
        text: PrioridadEstado[priority].toUpperCase(),
        color: colorMappingPriority[priority],
      };
    },
    setFormPaymentStatus(state, action) {
      const paymentStatus: OrdenEstadoDePago = action.payload;

      state.paymentStatus = {
        id: paymentStatus,
        text: OrdenEstadoDePagoLabels[paymentStatus].toUpperCase(),
        color: colorMappingPaymentStatus[paymentStatus],
      };
    },
    setModifyingProducts(state) {
      // Guardar estado anterior.
      state.previousState = {
        status: state.status,
        actions: state.actions,
      };
      state.actions = {
        guardar: {
          tooltip: 'Por favor, termine de modificar productos para guardar.',
          disabled: true,
          visible: true,
        },
        prioridad: {
          visible: false,
          disabled: true,
          tooltip: 'Seleccionar prioridad',
        },
        modificar: {
          visible: false,
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para modificar.',
        },
        remitoOrden: {
          visible: false,
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
        facturarOrden: {
          visible: false,
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
        anularOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
        marcarRecibidaOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
        marcarEnProduccionOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
        terminarOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
        marcarControladaOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
        marcarDespachadaOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
        rechazarOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
        finalizarOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
        reporte: {
          visible: false,
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
        marcarPlanificadaOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Por favor, termine de modificar productos para guardar.',
        },
      };
    },
    setModifyingProductsFinished(state) {
      // Restaurar estado anterior
      state.status = state.previousState!.status;
      state.actions = state.previousState!.actions;
      state.previousState = null;
    },
    setModifying(state) {
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        prioridad: {
          visible: true,
          disabled: false,
          tooltip: 'Seleccionar prioridad',
        },
        modificar: {
          visible: false,
          disabled: true,
          tooltip: 'Modificar',
        },
        marcarPlanificadaOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar la orden planificada',
        },
        remitoOrden: {
          visible: false,
          disabled: true,
          tooltip: 'Generar Remito',
        },
        facturarOrden: {
          visible: false,
          disabled: true,
          tooltip: 'Facturar Orden',
        },
        anularOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Anular Orden',
        },
        marcarRecibidaOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar la orden recibida',
        },
        marcarEnProduccionOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar la orden en producción',
        },
        terminarOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Terminar orden',
        },
        marcarControladaOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar la orden controlada',
        },
        marcarDespachadaOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Marcar la orden despachada',
        },
        rechazarOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Rechazar orden',
        },
        finalizarOrdenF: {
          visible: false,
          disabled: true,
          tooltip: 'Finalizar orden',
        },
        reporte: {
          visible: false,
          disabled: true,
          tooltip: 'Generar reporte',
        },
      };

      state.data = {
        reason: {
          readOnly: false,
          value: 'A completar',
          visible: true,
        },
        moraDias: { readOnly: true },
        produccionDias: { readOnly: true },
        descuento: { readOnly: true },
        pagoDemoradoDias: { readOnly: true },
        pagadaPorcentaje: { readOnly: true },
        lote: { readOnly: false },
        nroProveedor: { readOnly: false },
        nroOcCliente: { readOnly: false },
        fechaOc: { readOnly: false },
        fechaEntrega: { readOnly: false },
        plazoEntrega: { readOnly: false },
        observaciones: { readOnly: false },
        fechaPlanProduccion: { readOnly: false },
        fechaInicioProduccion: { readOnly: false },
        fechaTerminado: { readOnly: false },
        cotizacionNro: { readOnly: false },
        totalPagado: { readOnly: true },
      };

      state.productos = {
        readOnly: false,
      };
    },
  },
  // thunks fulfilled:
  extraReducers: (builder) => {
    builder.addCase(marcarPlanificadaOrdenF.fulfilled, (state, action) => {
      setPlanificada(state);
    });
    builder.addCase(anularOrdenF.fulfilled, (state, action) => {
      setAnulada(state);
    });
    builder.addCase(marcarRecibidaOrdenF.fulfilled, (state, action) => {
      setRecibida(state);
    });
    builder.addCase(marcarEnProduccionOrdenF.fulfilled, (state, action) => {
      setProduccion(state);
    });
    builder.addCase(terminarOrdenF.fulfilled, (state, action) => {
      setTerminada(state);
    });
    builder.addCase(marcarControladaOrdenF.fulfilled, (state, action) => {
      setControlada(state);
    });
    builder.addCase(marcarDespachadaOrdenF.fulfilled, (state, action) => {
      setDespachada(state);
    });
    builder.addCase(rechazarOrdenF.fulfilled, (state, action) => {
      setRechazada(state);
    });
    builder.addCase(finalizarOrdenF.fulfilled, (state, action) => {
      setFinalizada(state);
    });
  },
});

// Sets

const setBorrador = (state: any) => {
  state.status = {
    id: OrdenEstado.Borrador,
    text: OrdenEstado[OrdenEstado.Borrador].toUpperCase(),
    color: colorMapping[OrdenEstado.Borrador],
  };
  state.actions = {
    guardar: {
      visible: true,
      disabled: false,
      tooltip: 'Guardar',
    },
    prioridad: {
      visible: true,
      disabled: false,
      tooltip: 'Seleccionar prioridad',
    },
    modificar: {
      visible: false,
      disabled: true,
      tooltip: 'No se puede modificar en borrador.',
    },
    marcarPlanificadaOrdenF: {
      visible: true,
      disabled: false,
      tooltip: 'Marcar la orden planificada',
    },
    remitoOrden: {
      visible: false,
      disabled: true,
      tooltip: 'Generar Remito',
    },
    reporte: {
      visible: true,
      disabled: false,
      tooltip: 'Visualizar reporte',
    },
    facturarOrden: {
      visible: false,
      disabled: true,
      tooltip: 'Facturar Orden',
    },
    anularOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Anular Orden',
    },
    marcarRecibidaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden recibida',
    },
    marcarEnProduccionOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden en producción',
    },
    terminarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Terminar orden',
    },
    marcarControladaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden controlada',
    },
    marcarDespachadaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden despachada',
    },
    rechazarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Rechazar orden',
    },
    finalizarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Finalizar orden',
    },
  };

  state.data = {
    reason: {
      readOnly: true,
      value: 'Modificaciones en borrador',
      visible: false,
    },
    moraDias: { readOnly: true, visible: false },
    produccionDias: { readOnly: true, visible: false },
    descuento: { readOnly: true },
    pagoDemoradoDias: { readOnly: true, visible: false },
    pagadaPorcentaje: { readOnly: true, visible: false },
    lote: { readOnly: false },
    nroProveedor: { readOnly: false },
    nroOcCliente: { readOnly: false },
    fechaOc: { readOnly: false },
    fechaEntrega: { readOnly: false, visible: false },
    plazoEntrega: { readOnly: false },
    observaciones: { readOnly: false },
    fechaPlanProduccion: { readOnly: true, visible: false },
    fechaInicioProduccion: { readOnly: true, visible: false },
    fechaTerminado: { readOnly: true, visible: false },
    cotizacionNro: { readOnly: false },
    totalPagado: { readOnly: true, visible: false },
  };
};

const setAnulada = (state: any) => {
  state.status = {
    id: OrdenEstado.Anulada,
    text: OrdenEstado[OrdenEstado.Anulada].toUpperCase(),
    color: colorMapping[OrdenEstado.Anulada],
  };
  state.actions = {
    guardar: {
      visible: false,
      disabled: true,
      tooltip: 'Guardar',
    },
    revertir: {
      visible: true,
      disabled: false,
      tooltip: 'Revertir la anulación y volver al estado anterior',
    },
    reporte: {
      visible: false,
      disabled: true,
      tooltip: 'Generar reporte',
    },
    prioridad: {
      visible: false,
      disabled: true,
      tooltip: 'Seleccionar prioridad',
    },
    modificar: {
      visible: true,
      disabled: false,
      tooltip: 'Modificar',
    },
    marcarPlanificadaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden planificada',
    },
    remitoOrden: {
      visible: false,
      disabled: true,
      tooltip: 'Generar Remito',
    },
    facturarOrden: {
      visible: false,
      disabled: true,
      tooltip: 'Facturar Orden',
    },
    anularOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Anular Orden',
    },
    marcarRecibidaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden recibida',
    },
    marcarEnProduccionOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden en producción',
    },
    terminarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Terminar orden',
    },
    marcarControladaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden controlada',
    },
    marcarDespachadaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden despachada',
    },
    rechazarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Rechazar orden',
    },
    finalizarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Finalizar orden',
    },
  };
  state.productos = {
    readOnly: true,
  };
  state.data = {
    reason: {
      readOnly: true,
      value: '',
      visible: false,
    },
    moraDias: { readOnly: true },
    produccionDias: { readOnly: true },
    descuento: { readOnly: true },
    pagoDemoradoDias: { readOnly: true },
    pagadaPorcentaje: { readOnly: true },
    lote: { readOnly: true },
    nroProveedor: { readOnly: true },
    nroOcCliente: { readOnly: true },
    fechaOc: { readOnly: true },
    fechaEntrega: { readOnly: true },
    plazoEntrega: { readOnly: true },
    observaciones: { readOnly: true },
    fechaPlanProduccion: { readOnly: true },
    fechaInicioProduccion: { readOnly: true },
    fechaTerminado: { readOnly: true },
    cotizacionNro: { readOnly: true },
    totalPagado: { readOnly: true },
  };
};

const setRechazada = (state: any) => {
  state.status = {
    id: OrdenEstado.Rechazada,
    text: OrdenEstado[OrdenEstado.Rechazada].toUpperCase(),
    color: colorMapping[OrdenEstado.Rechazada],
  };
  state.productos = {
    readOnly: true,
  };
  state.actions = {
    guardar: {
      visible: false,
      disabled: true,
      tooltip: 'Guardar',
    },
    reporte: {
      visible: false,
      disabled: true,
      tooltip: 'Generar reporte',
    },
    prioridad: {
      visible: false,
      disabled: true,
      tooltip: 'Seleccionar prioridad',
    },
    modificar: {
      visible: true,
      disabled: false,
      tooltip: 'Modificar',
    },
    marcarPlanificadaOrdenF: {
      visible: true,
      disabled: false,
      text: 'Replanificar',
      tooltip: 'Volver a marcar la orden planificada',
    },
    remitoOrden: {
      visible: false,
      disabled: true,
      tooltip: 'Generar Remito',
    },
    facturarOrden: {
      visible: false,
      disabled: true,
      tooltip: 'Facturar Orden',
    },
    anularOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Anular Orden',
    },
    marcarRecibidaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden recibida',
    },
    marcarEnProduccionOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden en producción',
    },
    terminarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Terminar orden',
    },
    marcarControladaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden controlada',
    },
    marcarDespachadaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden despachada',
    },
    rechazarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Rechazar orden',
    },
    finalizarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Finalizar orden',
    },
  };
  state.data = {
    reason: { readOnly: true, value: '', visible: false },
    moraDias: { readOnly: true },
    produccionDias: { readOnly: true },
    descuento: { readOnly: true },
    pagoDemoradoDias: { readOnly: true },
    pagadaPorcentaje: { readOnly: true },
    lote: { readOnly: true },
    nroProveedor: { readOnly: true },
    nroOcCliente: { readOnly: true },
    fechaOc: { readOnly: true },
    fechaEntrega: { readOnly: true },
    plazoEntrega: { readOnly: true },
    observaciones: { readOnly: true },
    fechaPlanProduccion: { readOnly: true },
    fechaInicioProduccion: { readOnly: true },
    fechaTerminado: { readOnly: true },
    cotizacionNro: { readOnly: true },
    totalPagado: { readOnly: true },
  };
};

const setRecibida = (state: any) => {
  state.status = {
    id: OrdenEstado.Recibida,
    text: OrdenEstado[OrdenEstado.Recibida].toUpperCase(),
    color: '#70BDFF',
  };
  state.actions = {
    guardar: {
      visible: false,
      disabled: true,
      tooltip: 'Guardar',
    },
    prioridad: {
      visible: false,
      disabled: true,
      tooltip: 'Seleccionar prioridad',
    },
    modificar: {
      visible: true,
      disabled: false,
      tooltip: 'Modificar',
    },
    reporte: {
      visible: true,
      disabled: false,
      tooltip: 'Generar reporte',
    },
    marcarPlanificadaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden planificada',
    },
    remitoOrden: {
      visible: false,
      disabled: true,
      tooltip: 'Generar Remito',
    },
    facturarOrden: {
      visible: true,
      disabled: false,
      tooltip: 'Facturar Orden',
    },
    anularOrdenF: {
      visible: true,
      disabled: false,
      tooltip: 'Anular Orden',
    },
    marcarRecibidaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden recibida',
    },
    marcarEnProduccionOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden en producción',
    },
    terminarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Terminar orden',
    },
    marcarControladaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden controlada',
    },
    marcarDespachadaOrdenF: {
      visible: true,
      disabled: false,
      text: 'Volver a despachada',
      tooltip: 'Volver a marcar la orden despachada',
    },
    rechazarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Rechazar orden',
    },
    finalizarOrdenF: {
      visible: true,
      disabled: false,
      tooltip: 'Finalizar orden',
    },
  };
  state.data = {
    reason: { readOnly: true, value: '', visible: false },
    moraDias: { readOnly: true },
    produccionDias: { readOnly: true },
    descuento: { readOnly: true },
    pagoDemoradoDias: { readOnly: true },
    pagadaPorcentaje: { readOnly: true },
    lote: { readOnly: true },
    nroProveedor: { readOnly: true },
    nroOcCliente: { readOnly: true },
    fechaOc: { readOnly: true },
    fechaEntrega: { readOnly: true },
    plazoEntrega: { readOnly: true },
    observaciones: { readOnly: true },
    fechaPlanProduccion: { readOnly: true },
    fechaInicioProduccion: { readOnly: true },
    fechaTerminado: { readOnly: true },
    cotizacionNro: { readOnly: true },
    totalPagado: { readOnly: true },
  };
  state.productos = {
    readOnly: true,
  };
};

const setPlanificada = (state: any) => {
  state.status = {
    id: OrdenEstado.Planificada,
    text: OrdenEstado[OrdenEstado.Planificada].toUpperCase(),
    color: colorMapping[OrdenEstado.Planificada],
  };
  state.productos = {
    readOnly: true,
  };
  state.actions = {
    guardar: {
      visible: false,
      disabled: true,
      tooltip: 'Guardar',
    },
    prioridad: {
      visible: false,
      disabled: true,
      tooltip: 'Seleccionar prioridad',
    },
    reporte: {
      visible: true,
      disabled: false,
      tooltip: 'Generar reporte',
    },
    modificar: {
      visible: true,
      disabled: false,
      tooltip: 'Modificar',
    },
    marcarPlanificadaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden planificada',
    },
    remitoOrden: {
      visible: false,
      disabled: true,
      tooltip: 'Generar Remito',
    },
    facturarOrden: {
      visible: true,
      disabled: false,
      tooltip: 'Facturar Orden',
    },
    anularOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Anular Orden',
    },
    marcarRecibidaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden recibida',
    },
    marcarEnProduccionOrdenF: {
      visible: true,
      disabled: false,
      tooltip: 'Marcar la orden en producción',
    },
    terminarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Terminar orden',
    },
    marcarControladaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden controlada',
    },
    marcarDespachadaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden despachada',
    },
    rechazarOrdenF: {
      visible: true,
      disabled: false,
      tooltip: 'Rechazar orden',
    },
    finalizarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Finalizar orden',
    },
  };
  state.data = {
    reason: { readOnly: true, value: '', visible: false },
    moraDias: { readOnly: true },
    produccionDias: { readOnly: true },
    descuento: { readOnly: true },
    pagoDemoradoDias: { readOnly: true },
    pagadaPorcentaje: { readOnly: true },
    lote: { readOnly: true },
    nroProveedor: { readOnly: true },
    nroOcCliente: { readOnly: true },
    fechaOc: { readOnly: true },
    fechaEntrega: { readOnly: true },
    plazoEntrega: { readOnly: true },
    observaciones: { readOnly: true },
    fechaPlanProduccion: { readOnly: true },
    fechaInicioProduccion: { readOnly: true },
    fechaTerminado: { readOnly: true },
    cotizacionNro: { readOnly: true },
    totalPagado: { readOnly: true },
  };
};

const setProduccion = (state: any) => {
  state.status = {
    id: OrdenEstado.Produccion,
    text: OrdenEstado[OrdenEstado.Produccion].toUpperCase(),
    color: colorMapping[OrdenEstado.Produccion],
  };
  state.productos = {
    readOnly: true,
  };
  state.actions = {
    guardar: {
      visible: false,
      disabled: true,
      tooltip: 'Guardar',
    },
    reporte: {
      visible: true,
      disabled: false,
      tooltip: 'Generar reporte',
    },
    prioridad: {
      visible: false,
      disabled: true,
      tooltip: 'Seleccionar prioridad',
    },
    modificar: {
      visible: true,
      disabled: false,
      tooltip: 'Modificar',
    },
    marcarPlanificadaOrdenF: {
      visible: true,
      disabled: false,
      text: 'Replanificar',
      tooltip: 'Volver a marcar la orden planificada',
    },
    remitoOrden: {
      visible: false,
      disabled: true,
      tooltip: 'Generar Remito',
    },
    facturarOrden: {
      visible: true,
      disabled: false,
      tooltip: 'Facturar Orden',
    },
    anularOrdenF: {
      visible: true,
      disabled: false,
      tooltip: 'Anular Orden',
    },
    marcarRecibidaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden recibida',
    },
    marcarEnProduccionOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden en producción',
    },
    terminarOrdenF: {
      visible: true,
      disabled: false,
      tooltip: 'Terminar orden',
    },
    marcarControladaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden controlada',
    },
    marcarDespachadaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden despachada',
    },
    rechazarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Rechazar orden',
    },
    finalizarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Finalizar orden',
    },
  };
  state.data = {
    reason: { readOnly: true, value: '', visible: false },
    moraDias: { readOnly: true },
    produccionDias: { readOnly: true },
    descuento: { readOnly: true },
    pagoDemoradoDias: { readOnly: true },
    pagadaPorcentaje: { readOnly: true },
    lote: { readOnly: true },
    nroProveedor: { readOnly: true },
    nroOcCliente: { readOnly: true },
    fechaOc: { readOnly: true },
    fechaEntrega: { readOnly: true },
    plazoEntrega: { readOnly: true },
    observaciones: { readOnly: true },
    fechaPlanProduccion: { readOnly: true },
    fechaInicioProduccion: { readOnly: true },
    fechaTerminado: { readOnly: true },
    cotizacionNro: { readOnly: true },
    totalPagado: { readOnly: true },
  };
};

const setTerminada = (state: any) => {
  state.status = {
    id: OrdenEstado.Terminada,
    text: OrdenEstado[OrdenEstado.Terminada].toUpperCase(),
    color: colorMapping[OrdenEstado.Terminada],
  };
  state.productos = {
    readOnly: true,
  };
  state.actions = {
    guardar: {
      visible: false,
      disabled: true,
      tooltip: 'Guardar',
    },
    reporte: {
      visible: true,
      disabled: false,
      tooltip: 'Generar reporte',
    },
    prioridad: {
      visible: false,
      disabled: true,
      tooltip: 'Seleccionar prioridad',
    },
    modificar: {
      visible: true,
      disabled: false,
      tooltip: 'Modificar',
    },
    marcarPlanificadaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden planificada',
    },
    remitoOrden: {
      visible: false,
      disabled: true,
      tooltip: 'Generar Remito',
    },
    facturarOrden: {
      visible: true,
      disabled: false,
      tooltip: 'Facturar Orden',
    },
    anularOrdenF: {
      visible: true,
      disabled: false,
      tooltip: 'Anular Orden',
    },
    marcarRecibidaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden recibida',
    },
    marcarEnProduccionOrdenF: {
      visible: true,
      disabled: false,
      text: 'Producción',
      tooltip: 'Volver a marcar la orden en producción',
    },
    terminarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Terminar orden',
    },
    marcarControladaOrdenF: {
      visible: true,
      disabled: false,
      tooltip: 'Marcar la orden controlada',
    },
    marcarDespachadaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden despachada',
    },
    rechazarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Rechazar orden',
    },
    finalizarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Finalizar orden',
    },
  };
  state.data = {
    reason: { readOnly: true, value: '', visible: false },
    moraDias: { readOnly: true },
    produccionDias: { readOnly: true },
    descuento: { readOnly: true },
    pagoDemoradoDias: { readOnly: true },
    pagadaPorcentaje: { readOnly: true },
    lote: { readOnly: true },
    nroProveedor: { readOnly: true },
    nroOcCliente: { readOnly: true },
    fechaOc: { readOnly: true },
    fechaEntrega: { readOnly: true },
    plazoEntrega: { readOnly: true },
    observaciones: { readOnly: true },
    fechaPlanProduccion: { readOnly: true },
    fechaInicioProduccion: { readOnly: true },
    fechaTerminado: { readOnly: true },
    cotizacionNro: { readOnly: true },
    totalPagado: { readOnly: true },
  };
};

const setControlada = (state: any) => {
  state.status = {
    id: OrdenEstado.Controlada,
    text: OrdenEstado[OrdenEstado.Controlada].toUpperCase(),
    color: colorMapping[OrdenEstado.Controlada],
  };
  state.productos = {
    readOnly: true,
  };
  state.actions = {
    guardar: {
      visible: false,
      disabled: true,
      tooltip: 'Guardar',
    },
    reporte: {
      visible: true,
      disabled: false,
      tooltip: 'Generar reporte',
    },
    prioridad: {
      visible: false,
      disabled: true,
      tooltip: 'Seleccionar prioridad',
    },
    modificar: {
      visible: true,
      disabled: false,
      tooltip: 'Modificar',
    },
    marcarPlanificadaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden planificada',
    },
    remitoOrden: {
      visible: false,
      disabled: true,
      tooltip: 'Generar Remito',
    },
    facturarOrden: {
      visible: true,
      disabled: false,
      tooltip: 'Facturar Orden',
    },
    anularOrdenF: {
      visible: true,
      disabled: false,
      tooltip: 'Anular Orden',
    },
    marcarRecibidaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden recibida',
    },
    marcarEnProduccionOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden en producción',
    },
    terminarOrdenF: {
      visible: true,
      disabled: false,
      text: 'Re-Terminar',
      tooltip: 'Volver orden a estado Terminada',
    },
    marcarControladaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden controlada',
    },
    marcarDespachadaOrdenF: {
      visible: true,
      disabled: false,
      tooltip: 'Marcar la orden despachada',
    },
    rechazarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Rechazar orden',
    },
    finalizarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Finalizar orden',
    },
  };
  state.data = {
    reason: { readOnly: true, value: '', visible: false },
    moraDias: { readOnly: true },
    produccionDias: { readOnly: true },
    descuento: { readOnly: true },
    pagoDemoradoDias: { readOnly: true },
    pagadaPorcentaje: { readOnly: true },
    lote: { readOnly: true },
    nroProveedor: { readOnly: true },
    nroOcCliente: { readOnly: true },
    fechaOc: { readOnly: true },
    fechaEntrega: { readOnly: true },
    plazoEntrega: { readOnly: true },
    observaciones: { readOnly: true },
    fechaPlanProduccion: { readOnly: true },
    fechaInicioProduccion: { readOnly: true },
    fechaTerminado: { readOnly: true },
    cotizacionNro: { readOnly: true },
    totalPagado: { readOnly: true },
  };
};

const setDespachada = (state: any) => {
  state.status = {
    id: OrdenEstado.Despachada,
    text: OrdenEstado[OrdenEstado.Despachada].toUpperCase(),
    color: colorMapping[OrdenEstado.Despachada],
  };
  state.productos = {
    readOnly: true,
  };
  state.actions = {
    guardar: {
      visible: false,
      disabled: true,
      tooltip: 'Guardar',
    },
    reporte: {
      visible: true,
      disabled: false,
      tooltip: 'Generar reporte',
    },
    prioridad: {
      visible: false,
      disabled: true,
      tooltip: 'Seleccionar prioridad',
    },
    modificar: {
      visible: true,
      disabled: false,
      tooltip: 'Modificar',
    },
    marcarPlanificadaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden planificada',
    },
    remitoOrden: {
      visible: false,
      disabled: true,
      tooltip: 'Generar Remito',
    },
    facturarOrden: {
      visible: true,
      disabled: false,
      tooltip: 'Facturar Orden',
    },
    anularOrdenF: {
      visible: true,
      disabled: false,
      tooltip: 'Anular Orden',
    },
    marcarRecibidaOrdenF: {
      visible: true,
      disabled: false,
      tooltip: 'Marcar la orden recibida',
    },
    marcarEnProduccionOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden en producción',
    },
    terminarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Terminar orden',
    },
    marcarControladaOrdenF: {
      visible: true,
      disabled: false,
      text: 'Volver a controlada',
      tooltip: 'Volver a marcar la orden controlada',
    },
    marcarDespachadaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden despachada',
    },
    rechazarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Rechazar orden',
    },
    finalizarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Finalizar orden',
    },
  };
  state.data = {
    reason: { readOnly: true, value: '', visible: false },
    moraDias: { readOnly: true },
    produccionDias: { readOnly: true },
    descuento: { readOnly: true },
    pagoDemoradoDias: { readOnly: true },
    pagadaPorcentaje: { readOnly: true },
    lote: { readOnly: true },
    nroProveedor: { readOnly: true },
    nroOcCliente: { readOnly: true },
    fechaOc: { readOnly: true },
    fechaEntrega: { readOnly: true },
    plazoEntrega: { readOnly: true },
    observaciones: { readOnly: true },
    fechaPlanProduccion: { readOnly: true },
    fechaInicioProduccion: { readOnly: true },
    fechaTerminado: { readOnly: true },
    cotizacionNro: { readOnly: true },
    totalPagado: { readOnly: true },
  };
};

const setFinalizada = (state: any) => {
  state.status = {
    id: OrdenEstado.Finalizada,
    text: OrdenEstado[OrdenEstado.Finalizada].toUpperCase(),
    color: colorMapping[OrdenEstado.Finalizada],
  };
  state.productos = {
    readOnly: true,
  };
  state.actions = {
    guardar: {
      visible: false,
      disabled: true,
      tooltip: 'Guardar',
    },
    reporte: {
      visible: true,
      disabled: false,
      tooltip: 'Generar reporte',
    },
    prioridad: {
      visible: false,
      disabled: true,
      tooltip: 'Seleccionar prioridad',
    },
    modificar: {
      visible: true,
      disabled: false,
      tooltip: 'Modificar',
    },
    marcarPlanificadaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden planificada',
    },
    remitoOrden: {
      visible: false,
      disabled: true,
      tooltip: 'Generar Remito',
    },
    facturarOrden: {
      visible: true,
      disabled: false,
      tooltip: 'Facturar Orden',
    },
    anularOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Anular Orden',
    },
    marcarRecibidaOrdenF: {
      visible: true,
      disabled: false,
      text: 'Volver a recibida',
      tooltip: 'Volver a marcar la orden recibida',
    },
    marcarEnProduccionOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden en producción',
    },
    terminarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Terminar orden',
    },
    marcarControladaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden controlada',
    },
    marcarDespachadaOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Marcar la orden despachada',
    },
    rechazarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Rechazar orden',
    },
    finalizarOrdenF: {
      visible: false,
      disabled: true,
      tooltip: 'Finalizar orden',
    },
  };
  state.data = {
    reason: { readOnly: true, value: '', visible: false },
    moraDias: { readOnly: true },
    produccionDias: { readOnly: true },
    descuento: { readOnly: true },
    pagoDemoradoDias: { readOnly: true },
    pagadaPorcentaje: { readOnly: true },
    lote: { readOnly: true },
    nroProveedor: { readOnly: true },
    nroOcCliente: { readOnly: true },
    fechaOc: { readOnly: true },
    fechaEntrega: { readOnly: true },
    plazoEntrega: { readOnly: true },
    observaciones: { readOnly: true },
    fechaPlanProduccion: { readOnly: true },
    fechaInicioProduccion: { readOnly: true },
    fechaTerminado: { readOnly: true },
    cotizacionNro: { readOnly: true },
    totalPagado: { readOnly: true },
  };
};

// Selectors

export const selectFormStatus = (state: RootState) => state.orden.form.status;
export const selectFormPriority = (state: RootState) =>
  state.orden.form.priority;
export const selectRemitoOrden = (state: RootState) =>
  state.orden.form.actions?.remitoOrden;
export const selectFacturarOrden = (state: RootState) =>
  state.orden.form.actions?.facturarOrden;
export const selectAnularOrdenF = (state: RootState) =>
  state.orden.form.actions?.anularOrdenF;
export const selectMarcarRecibidaOrdenF = (state: RootState) =>
  state.orden.form.actions?.marcarRecibidaOrdenF;
export const selectMarcarEnProduccionOrdenF = (state: RootState) =>
  state.orden.form.actions?.marcarEnProduccionOrdenF;
export const selectTerminarOrdenF = (state: RootState) =>
  state.orden.form.actions?.terminarOrdenF;
export const selectMarcarControladaOrdenF = (state: RootState) =>
  state.orden.form.actions?.marcarControladaOrdenF;
export const selectMarcarDespachadaOrdenF = (state: RootState) =>
  state.orden.form.actions?.marcarDespachadaOrdenF;
export const selectRechazarOrdenF = (state: RootState) =>
  state.orden.form.actions?.rechazarOrdenF;
export const selectFinalizarOrdenF = (state: RootState) =>
  state.orden.form.actions?.finalizarOrdenF;
export const selectMarcarPlanificadaOrdenF = (state: RootState) =>
  state.orden.form.actions?.marcarPlanificadaOrdenF;
export const selectGuardar = (state: RootState) =>
  state.orden.form.actions?.guardar;
export const selectFormDataReason = (state: RootState) =>
  state.orden.form.data?.reason;
export const selectModificar = (state: RootState) =>
  state.orden.form.actions?.modificar;
export const selectPrioridad = (state: RootState) =>
  state.orden.form.actions?.prioridad;
export const selectRevertir = (state: RootState) =>
  state.orden.form.actions?.revertir;
export const selectFormPaymentStatus = (state: RootState) =>
  state.orden.form.paymentStatus;
export const selectReporte = (state: RootState) =>
  state.orden.form.actions?.reporte;

// Export actions
export const {
  resetForm,
  setModifying,
  setFormPriority,
  setFormPaymentStatus,
  setFormStatusBorrador,
  setFormStatusAnulada,
  setFormStatusRecibida,
  setFormStatusPlanificada,
  setFormStatusProduccion,
  setFormStatusTerminada,
  setFormStatusControlada,
  setFormStatusDespachada,
  setFormStatusRechazada,
  setFormStatusFinalizada,
  setModifyingProducts,
  setModifyingProductsFinished,
} = formSlice.actions;

export default formSlice.reducer;
